<template>
  <div class="status-stack">
    <Status
      :report="report"
      :flat="flat"
    />
    <SignatureChip
      :report="report"
      :flat="flat"
      class="q-mt-xs"
    />
  </div>
</template>

<script>
import Status from './Status'
import SignatureChip from './SignatureChip'

/**
 * The report status chip with the signature chip stacked under it. The stack is
 * sized by its widest chip (the fixed-width status chip), and the signature chip
 * stretches to it, so the two always match without a second hard-coded width.
 */
export default {
  components: {
    Status,
    SignatureChip
  },
  props: {
    report: {
      type: Object,
      required: true
    },
    flat: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.status-stack {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  align-self: flex-start;
}
</style>
